import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import Invoice from "../../common/Invoice";
import LogoUpload from "../../common/LogoUpload";
import Agreements from "./Agreements";
import Candidate from "../../common/Candidate";
import { EmptyForm, EmptySubmission, FormSchema } from "./model";
import Submission from "./Submission";
import Submitter from "../../common/Submitter";
import InfoBlock from './InfoBlock'
import { errorsWithPrefix } from '../../common/utils' 
import { set } from 'lodash/object'
import ButtonWithPopup from '../../common/ButtonWithPopup'

const FormPage = ({ onSubmit, termsAndConditions }) => {
    const [data, setData] = useState(EmptyForm);
    const [errors, setErrors] = useState({});

    const onChange = ({ name, value, key }) => {
        const newData = set({...data}, name, value)
        setData(newData)
    };

    const submit = e => {
        e.preventDefault();

        FormSchema.validate(data, { abortEarly: false }).then(
            () => onSubmit(data),
            reason => {
                const err = reason.inner.reduce((a, v) => ({ ...a, [v.path]: v }), {});
                setErrors(err);
            }
        );
    };

    const addSubmission = e => {
        e.preventDefault();
        const subs = [...data.submissions, { ...EmptySubmission, key: data.submissions.length }];
        setData({ ...data, submissions: subs });
    };

    const removeSubmission = key => {
    
        const subs = data.submissions.filter(it => it.key !== key).map((it, i) => ({ ...it, key: i }));
        setData({ ...data, submissions: subs });
    };

    const allowAddingSubmission = () => data.submissions.length < 3;

    return (
        <Form>
            <Candidate
                title="Nazwa zgłaszanego zespołu"
                model={data.candidate}
                errors={errorsWithPrefix(errors, "candidate")}
                onChange={value => onChange({ name: "candidate", value })}
            />
            <LogoUpload
                model={data.logo}
                errors={errorsWithPrefix(errors, "logo")}
                onChange={value => onChange({ name: "logo", value })}
            />
            <Submitter
                model={data.submitter}
                errors={errorsWithPrefix(errors, "submitter")}
                onChange={value => onChange({ name: "submitter", value })}
            />
            <Invoice
                model={data.invoice}
                errors={errorsWithPrefix(errors, "invoice")}
                onChange={value => onChange({ name: "invoice", value })}
            />
            <InfoBlock />
            <Agreements
                termsAndConditions={termsAndConditions}
                model={data.agreements}
                errors={errorsWithPrefix(errors, "agreements")}
                onChange={value => onChange({ name: "agreements", value })}
            />
            {data.submissions.map(it => (
                <Submission
                    key={it.key}
                    model={it}
                    errors={errorsWithPrefix(errors, `submissions[${it.key}]`)}
                    onChange={value => onChange({ name: `submissions[${it.key}]`, value })}
                    onRemove={removeSubmission}
                />
            ))}
            <Form.Group inline className="actions">
                {allowAddingSubmission() && (
                    <Button onClick={addSubmission} primary={data.submissions.length === 0}>
                        Dodaj kategorię
                    </Button>
                )}
                {data.submissions.length > 0 && (
                    <ButtonWithPopup
                        errors={errors}
                        button={
                            <Button onClick={submit} primary>
                                Wyślij zgłoszenie
                            </Button>
                        }
                    />
                )}
            </Form.Group>
        </Form>
    );
};

export default FormPage;

